import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { FormControl } from 'react-bootstrap';
import cn from 'classnames';

import TextContainer from './TextContainer';

const Text = props => (
  <Field {...props} component={TextContainer}>
    <TextField />
  </Field>
);

const TextField = ({ edit, bsClass, input, ...props }) => {
  if (!edit) {
    const { value } = input;
    return <div className="editable-value">{value || ''}</div>;
  }
  const { onChange } = input;
  return (
    <FormControl
      {...props}
      {...input}
      type="text"
      bsClass={cn('form-control', bsClass)}
      onChange={evt => onChange(evt)}
      className="input-editing--text"
    />
  );
};

TextField.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string
  }),
  bsClass: PropTypes.object,
  edit: PropTypes.bool
};

TextField.defaultProps = {
  input: { value: '', onChange: () => undefined }
};

export default Text;
export { TextField };
